export const SLUG_ALL_SPORTS: string = 'all'
export const SPORTS_LIMIT = 3

// Sports Tabs
export enum SportsTabs {
  SPORT = 'SPORT'
}

export enum CategoriesSlug {
  ALL = 'all',
  TODAY = 'today',
  TOMORROW = 'tomorrow'
}

export interface CategoryItem {
  name: string
  slug: CategoriesSlug
}
